import { DatePicker, Modal } from 'antd'
import React, { useRef } from 'react'
import { Colors } from '../../config'
import DynamicForm from '../FormElements/DynamicForm'
import CustomYearPicker from '../BookingFormComponents/CustomYearPicker'
import { useMutation } from 'react-query'
import * as Yup from 'yup';
import axiosInstance from '../../config/api'
import { useDispatch } from 'react-redux'
import { setError, setMessage } from '../../store/common/generalSlice'

//PROPS ==
// vehicleRegistrationModalOpen = state to open Modal
// setVehicleRegistrationModalOpen = setstate to handle modal open or close
// vehicleRegistrationFormDataHandler = sending data to the parent component i.e booking form.

const VehicleRegistration = ({ vehicleRegistrationModalOpen, setVehicleRegistrationModalOpen, vehicleRegistrationFormDataHandler }) => {

    const vehicleRegistrationRef = useRef(null);
    const dispatch = useDispatch()

    const addNewCarMutation = useMutation(async (data) => {
        // setting isManual true to clearify this case is for manually adding car.
        // whenever the modal gets open.
        data.status = true;
        data.isManual = true;
        const resp = await axiosInstance.post('/mygarage/vehicles/add', data);
        return resp
    },
        {
            onSuccess: (resp) => {
                vehicleRegistrationFormDataHandler(resp);
                setVehicleRegistrationModalOpen(false);
                dispatch(setMessage(resp?.data?.data?.message))
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const form = {
        name: 'Add car registration',
        formFields: [
            {
                name: 'make',
                label: { value: 'Make:', classes: '' },
                type: 'text',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'custom-card-boxshadow border-none outline-none h-10',
                icon: null
            },
            {
                name: 'model',
                label: { value: 'Model:', classes: '' },
                type: 'text',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'custom-card-boxshadow border-none outline-none h-10',
                icon: null
            },
            {
                name: 'engineSize',
                label: { value: 'Engine size:', classes: '' },
                type: 'text',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'custom-card-boxshadow border-none outline-none h-10',
                icon: null
            },
            {
                name: 'fuelType',
                label: { value: 'Fuel Type:', classes: '' },
                type: 'text',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: 'custom-card-boxshadow border-none outline-none h-10',
                icon: null
            },
            {
                name: 'year',
                label: { value: 'Year:', classes: '' },
                type: 'custom',
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <CustomYearPicker />,
                classes: 'custom-card-boxshadow border-none outline-none h-10',
                icon: null
            }
        ],
        formValidation: {
            make: Yup.string()
                .matches(/^[a-zA-Z0-9]*$/, 'Must be alphanumeric')
                .min(1, 'Must be at least 1 character long')
                .max(500, 'Cannot be longer than 500 characters')
                .required('This field is required')
            ,
            model: Yup.string()
                .matches(/^[a-zA-Z0-9]*$/, 'Must be alphanumeric')
                .max(500, 'Cannot be longer than 500 characters')
                .notRequired()
            ,
            engine: Yup.string()
                .matches(/^[0-9]*$/, 'Must be numeric')
                .max(500, 'Cannot be longer than 500 characters')
                .notRequired()
            ,
            fuel_type: Yup.string()
                .matches(/^[a-zA-Z0-9]*$/, 'Must be alphanumeric')
                .max(500, 'Cannot be longer than 500 characters')
                .notRequired()
            ,
        }
    }

    const vehicleRegistrationHandler = (data) => {
        if (data) {
            addNewCarMutation.mutate(data);
        }
    }

    const onModalSubmitter = () => {
        const divElement = vehicleRegistrationRef.current;
        if (divElement) {
            divElement.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
        }
    }

    return (
        <Modal
            title={<p className='w-full text-center pt-2'>Add New Vehicle</p>}
            width={400}
            centered
            open={vehicleRegistrationModalOpen}
            onCancel={() => setVehicleRegistrationModalOpen(false)}
            onOk={() => onModalSubmitter()}
            okText={'Submit'}
            destroyOnClose={true}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{
                className: 'w-11/12 h-10 bg-[#fab700] mr-[4%] mb-[1rem]',
                loading: addNewCarMutation?.isLoading
            }}
            className='my-4 md:my-0'
        >
            <div ref={vehicleRegistrationRef} className='p-4'>
                <DynamicForm form={form} onSubmit={vehicleRegistrationHandler} />
            </div>
        </Modal >
    )
}

export default VehicleRegistration

